export const useEnv = () => {
  const apiUrl = import.meta.env.VITE_API_URL
  const explorerUrl = import.meta.env.VITE_EXPLORER_URL
  const upiId = import.meta.env.VITE_UPI_ID
  const merchantName = import.meta.env.VITE_MERCHANT_NAME
  const rpcUrl = import.meta.env.VITE_RPC_URL
  const chainId = import.meta.env.VITE_CHAIN_ID

  return {
    apiUrl,
    explorerUrl,
    upiId,
    merchantName,
    rpcUrl,
    chainId
  }
}

export interface EnvConfig {
  apiUrl: string
  explorerUrl: string
  upiId: string
  merchantName: string
  rpcUrl: string
  chainId: string | number
}

export default useEnv 